import React from "react";
import { IList } from "../../../utils/generalType";
import { servicesPortfolio, serviceWorkflow } from "./Services/service.utils";
import Slide from "react-reveal/Slide";
import { Link } from "react-router-dom";
import { contactDetails } from "../../../utils/appconst";

const PortServiceWorkFlowComp = () => {
  const workflow: IList[] = serviceWorkflow;

  return (
    <>
      {/* Workflow Section */}
      <div className="text-center py-16">
        <Slide bottom>
          <h3 className="text-4xl font-semibold mb-2 space-y-2 text-gray-800 pb-8">
            Let's create Innovative Solutions To Boost Your <br />
            Business
          </h3>
        </Slide>
        <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {workflow.map((step, index) => (
            <Slide bottom delay={index * 200} key={index}>
              <div key={index}>
                <img
                  src={step.image}
                  alt={step.title}
                  className="rounded-lg mb-3"
                />
                <p className="font-medium text-lg">{step.title}</p>
              </div>
            </Slide>
          ))}
        </div>



        {/* See More Button */}
        <div className="text-center">
          <Slide up>
            <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
              <a
                href={`https://wa.me/${contactDetails?.whatsAppContact}?text=${contactDetails?.whatAppLeadingMessage}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="bg-green-500 text-white px-6 py-3 rounded-full hover:bg-green-600 transition">
                  Chat With Me
                </button>
              </a>

              <Link to="/contact">
                <button className="bg-white border border-green-700 text-gray-800 px-6 py-3 rounded-full hover:bg-gray-200 transition">
                  Contact Me
                </button>
              </Link>
            </div>
          </Slide>
        </div>

      </div>
    </>
  );
};

export default PortServiceWorkFlowComp;
